import { DocumentNode } from 'apollo-link';
import gql from 'graphql-tag';

export const VirtualConnectionTableQueryGql: DocumentNode = gql`
query VirtualConnectionTableQuery($vizportalUrlId: String!) {
  virtualConnectionTables(filter: {vizportalUrlId: $vizportalUrlId}, permissionMode: FILTER_RESULTS) {
    name
    columns (orderBy: { field: NAME, direction: ASC}) {
      name
      id
    }
  }
}
`;
